import { useSelector } from 'react-redux'
import { selectTranslations } from '../../../services/i18n/i18nSlice'
import Form from 'react-bootstrap/Form';
import { InfoTooltip } from '../../../components/InfoTooltip';

export default function TrainingInfo(props) {

    const t = useSelector(selectTranslations)

    const handleDataChange = (e) => {
        const target = e.target
        const name = target.name
        const value = target.type === "checkbox" ? target.checked : target.value
        props.onTrainingDataChange({
            ...props.trainingData,
            [name]: value
        })
    }

    return(
        <>
            <div className="info_card">
                <div className='d-flex justify-content-between align-items-center'>
                    <h2 className='mb-0'>{t.exam.primary_info}</h2>
                    { props.trainingData.ready ?
                        <div className='d-flex align-items-center'>
                            <span className='badge bg-success me-2'>{t.training.status_published}</span>
                            <button className='secondary text-danger' onClick={props.onSuspend}>
                                {t.training.suspend_training}
                            </button>
                        </div>
                    :
                        <span className='badge bg-secondary'>{t.training.status_draft}</span>
                    }
                </div>
                <Form.Group controlId="title" className='mt-3'>
                    <Form.Label>{t.training.title}*</Form.Label>
                    <Form.Control type="text" value={props.trainingData.training_title || ''} name="training_title" placeholder={t.training.title} required onChange={handleDataChange} />
                </Form.Group>
                <Form.Group controlId="description" className='mt-2'>
                    <Form.Label>{t.training.description}</Form.Label>
                    <Form.Control type="text" value={props.trainingData.description || ''} name="description" placeholder={t.training.description} onChange={handleDataChange} />
                </Form.Group>
                <Form.Group controlId="num_questions_per_training" className='mt-2'>
                    <Form.Label>{t.training.question_per_training}*</Form.Label>
                    <Form.Control type="number" value={props.trainingData.num_questions_per_training || ''} name="num_questions_per_training" placeholder={t.training.question_per_training} required min={1} onChange={handleDataChange} />
                </Form.Group><Form.Group controlId="required_correct_answers" className='mt-2'>
                    <Form.Label>{t.training.required_correct_answers}*</Form.Label>
                    <Form.Control type="number" value={props.trainingData.required_correct_answers || ''} name="required_correct_answers" placeholder={t.training.required_correct_answers} required min={1} onChange={handleDataChange} />
                </Form.Group>
            </div>
        </>
    )
}